import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);

export function formatDateToUserTimezone(date: string | Date) {
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return dayjs.utc(date).tz(userTimeZone).format("DD/MM/YYYY HH:mm (Z)"); // shwo timezone in the format of the user
}

export function formatDate(date: string | Date) {
  return dayjs(date).format("DD/MM/YYYY HH:mm");
}

export function getRelativeTime(date: string | Date): string {
  const d = dayjs(date);
  const now = dayjs();
  const diffHours = now.diff(d, "hour");
  const diffDays = now.diff(d, "day");

  if (diffHours < 1) {
    const diffMinutes = now.diff(d, "minute");

    if (diffMinutes < 1) return "just now";

    return `${diffMinutes}m ago`;
  }
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;
  if (diffDays < 30) return `${Math.floor(diffDays / 7)}w ago`;
  if (diffDays < 365) return `${Math.floor(diffDays / 30)}mo ago`;

  return `${Math.floor(diffDays / 365)}y ago`;
}

export function formatFullDate(date: string | Date): string {
  return dayjs(date).format("MMM D, YYYY [at] h:mm A");
}

/** "5 Oct 2026, 5:58 PM" */
export function formatDateTime(date: string | Date) {
  return dayjs(date).format("D MMM YYYY, h:mm A");
}

/** "5 Oct 2026" */
export function formatDay(date: string | Date) {
  return dayjs(date).format("D MMM YYYY");
}
